import {useTranslation} from "react-i18next";
import {useState} from "react";
import labelsDefault from "./labelsDefault";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableDeviceGroup = ({itemsShow, items, checkAll, setCheckAll, buttonsTB, setButtonsTB, orderingRef}) => {
    const [t] = useTranslation("tables");
    const [labels, setLabels] = useState(labelsDefault);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "169px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th key="-1" style={{width: "0.4%", ...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onClick={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxContainer"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={items.current.chosen.includes(item.id)}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td>{item.actives_count}</td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableDeviceGroup;
